import React, { FC } from 'react';

import styled from 'styled-components';

import { IRewardText } from './types';

const FancyText = styled.span`
  color: ${Styles.color.primary};
  font-family: ${Styles.fontFamily.brand};
  margin-right: 0.5rem;
`;

export const RewardText: FC<IRewardText> = ({ text }) => <FancyText>{text}</FancyText>;
